// extracted by mini-css-extract-plugin
module.exports = {"unknown":"PageNotFound_unknown__AmnRT","code":"PageNotFound_code__26vkt","text":"PageNotFound_text__18Zbh","home":"PageNotFound_home__26VRZ"};